module.exports = __webpack_public_path__ + "img/more_bj.6bfaa2e4.png";